import IMG1 from '../assets/images/hero/IMG_1.webp';
import IMG2 from '../assets/images/hero/IMG_2.webp';
import IMG3 from '../assets/images/hero/IMG_3.webp';
import IMG4 from '../assets/images/hero/IMG_4.webp';

export interface HeroSlide {
  id: number;
  src: string;
  alt: string;
  legend: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 1,
    src: IMG1,
    alt: 'CE-merkitty tiilenpunainen graniittimurske SFS-EN 13242 -standardin mukaisesti',
    legend: 'CE-merkitty tiilenpunainen graniittimurske - KAM 0-8, 0-16, 0-22, 0-32, 0-56 ja 0-90 mm',
  },
  {
    id: 2,
    src: IMG2,
    alt: 'Graniittimurske kantaviin ja jakaviin kerroksiin',
    legend: 'Murskeet KAM 0-32 ja 0-56 mm jakaviin kerroksiin, KAM 0-16 ja 0-22 mm kantaviin kerroksiin',
  },
  {
    id: 3,
    src: IMG3,
    alt: 'Käyttökohteita: betonin kiviaines ja asfalttipäällysteet',
    legend: 'Sepelit SEP 08-16 ja 16-32 mm salaojitukseen ja betonin kiviaineeksi',
  },
  {
    id: 4,
    src: IMG4,
    alt: 'SFS-EN 13242 -standardin mukaiset murskeet rakentamiseen',
    legend: 'SFS-EN 13242 standardin mukaiset rakennustuotteet - toimitus tai nouto',
  },
];
